export enum TipoImpressao {
    BOBINA_58 = 'BOBINA_58',
    BOBINA_80 = 'BOBINA_80',
    A4 = 'A4',
}